export * from './qualtrics-survey-feedback-submit.graphql';
